import React from 'react';
import {
  LandingSelectedEntities,
} from '../../../components';
import { VACANCY_OVERVIEW_URL } from '../../../config/constants';

const LandingSelectedVacancies = ({ id, entity }) => {

  return (
    <LandingSelectedEntities
      id={id}
      type="vacancies"
      link={VACANCY_OVERVIEW_URL}
      entities={entity.getIn(['field_landing_selected_vacancies'])}
      title={entity.getIn(['field_title', 0, 'value'])}
    />
  );
};

export default LandingSelectedVacancies;
